module.exports = __webpack_public_path__ + "img/restriction.f370a975.svg";